<template>
  <component :is="isNew ? IOrderMenu : IOrderMenuLegacy" v-bind="props" />
</template>

<script setup lang="ts">
import type { IOrderMenuProps, IOrderMenuFields } from './types';
import { computed } from 'vue';
import { useJssStore } from '../../stores/jssStore';
import IOrderMenu from './IOrderMenuNew.vue';
import IOrderMenuLegacy from '../IOrderMenuLegacy/IOrderMenuLegacy.vue';

const props = withDefaults(defineProps<IOrderMenuProps>(), {
  fields: () => ({}) as IOrderMenuFields,
  params: () => ({}),
});

const jssStore = useJssStore();
const isNew = computed(
  () =>
    (jssStore.$state as unknown as Record<string, unknown>)[
      'Feature.Menus.UseEnterpriseMenuApi'
    ] === 'true'
);
</script>

<style lang="scss">
@import './scss/IOrderMenu.scss';
</style>
